var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70711 0.292893C8.09763 0.683418 8.09763 1.31658 7.70711 1.70711L3.41396 6.00025H17C17.5523 6.00025 18 6.44796 18 7.00025C18 7.55253 17.5523 8.00025 17 8.00025H3.41446L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.305446 7.71966C0.129724 7.54996 0.0160041 7.31648 0.00158775 7.0565C-0.00201403 6.99247 0.000512118 6.92816 0.00916618 6.86451C0.0134628 6.83285 0.0192411 6.80166 0.0264295 6.77101C0.0674651 6.5958 0.156286 6.4295 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893Z",
    fill: "#6C63FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.ab913b67598ff1b9cc10869f9732cf20.svg";
export { ForwardRef as ReactComponent };